import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Store";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import DownloadSkillsReview from "./DownloadSkillsReview";
import ReviewEmployeesSkills from "./ReviewEmployeesSkills";
import SkillsView from "./SkillsView";
import SkillHistory from "./SkillHistory";
import SkillDocument from "./SkillDocument";
import UploadedDocuments from "./UploadedDocuments";
import EmployeesWithNoSkillResponses from "./EmployeesWithNoSkillResponses";
import SkillSectionManagement from "./SkillSectionManagement";
import DesignationSectionAssignment from "./DesignationSectionAssignment";

const ViewAllSkills = () => {
  const [value, setValue] = React.useState(0);

  // Use current acting role from Redux; fallback to persisted selectedRole
  const selectedRoleFromStore = useSelector((state: RootState) => state.auth.selectedRole);
  const selectedRole = selectedRoleFromStore || localStorage.getItem("selectedRole") || "";
  const isHR = selectedRole.toLowerCase() === "hr";

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (!isHR && newValue > 2) {
      setValue(0);
    } else {
      setValue(newValue);
    }
  };

  // Tab index offsets: 0-2 are shared, 3-8 are HR-only
  

  return (
    <Box sx={{ width: "100%", mt: 10, mb: 10 }}>
      
      {/* Tabs Section */}
      <Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          centered={false}
          textColor="inherit"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
            "& .MuiTab-root": { color: "black" },
            "& .Mui-selected": { color: "black" },
            "& .MuiTabs-flexContainer": { justifyContent: "center" },
          }}
        >
          <Tab {...a11yProps(0)} label={"Review Skills"} />
          <Tab {...a11yProps(1)} label={"Download Review"} />
          <Tab {...a11yProps(2)} label={"History"} />
          {isHR && (
            <Tab {...a11yProps(3)} label={"Skills Pending"} />
          )}
          {isHR && (
            <Tab {...a11yProps(4)} label={"Add Skills"} />
          )}
          {isHR && (
            <Tab {...a11yProps(5)} label={"Skills Document Upload"} />
          )}
          {isHR && (
            <Tab {...a11yProps(6)} label={"Uploaded Documents"} />
          )}
          {isHR && (
            <Tab {...a11yProps(7)} label={"Skill Sections"} />
          )}
          {isHR && (
            <Tab {...a11yProps(8)} label={"Roles Sections"} />
          )}
        </Tabs>
      </Box>

      {/* Content Section */}
      <Box sx={{ width: "100%" }}>
        <CustomTabPanel value={value} index={0}>
          <ReviewEmployeesSkills />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <DownloadSkillsReview />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <SkillHistory />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          {isHR && <EmployeesWithNoSkillResponses />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          {isHR && <SkillsView />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          {isHR && <SkillDocument />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
          {isHR && <UploadedDocuments />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={7}>
          {isHR && <SkillSectionManagement />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={8}>
          {isHR && <DesignationSectionAssignment />}
        </CustomTabPanel>
      </Box>
      
    </Box>
  );
};

export default ViewAllSkills;